var map = {
	"./auth/ConfirmPassword.vue": 52685,
	"./auth/ForgotPassword.vue": 68427,
	"./auth/Login.vue": 75477,
	"./auth/Register.vue": 24649,
	"./auth/ResetPassword.vue": 21511,
	"./auth/VerifyEmail.vue": 55231,
	"./bank/Bank.vue": 20049,
	"./bank/Transactions.vue": 15399,
	"./companies/Companies.vue": 33959,
	"./companies/CompanyGroups.vue": 87570,
	"./credit-cards/CreditCards.vue": 29468,
	"./dashboard/CustomerDashboard.vue": 29357,
	"./dashboard/Dashboard.vue": 76380,
	"./employees/Employees.vue": 14013,
	"./employees/UserCompanies.vue": 63444,
	"./employees/UserGroups.vue": 97560,
	"./errors/Forbidden.vue": 58160,
	"./errors/NotFound.vue": 94510,
	"./onboarding/CustomerIndex.vue": 22564,
	"./onboarding/Onboarding.vue": 34639,
	"./outlay/UserConnect.vue": 73156,
	"./power-bi/Dashboard.vue": 1845,
	"./power-bi/Setup.vue": 81352,
	"./profile/Profile.vue": 85967,
	"./roles/Roles.vue": 96029,
	"./salary/ActivityLog.vue": 82585,
	"./salary/EditHolidayPayObligation.vue": 22286,
	"./salary/EditPayroll.vue": 17236,
	"./salary/EmployeeOptionals.vue": 85202,
	"./salary/HolidayPayObligations.vue": 5926,
	"./salary/Holidays.vue": 40221,
	"./salary/Payrolls.vue": 40981,
	"./salary/Status.vue": 46087,
	"./salary/WorkCalendars.vue": 63740,
	"./system/DataFields.vue": 74931,
	"./system/Kube.vue": 86397,
	"./system/Log.vue": 68073,
	"./system/VatDeadlines.vue": 16364,
	"./task-templates/TaskTemplates.vue": 53996,
	"./users/Users.vue": 54823,
	"./vat/Vat.vue": 22110,
	"./voucher/Voucher.vue": 14762,
	"./voucher/VoucherEarlierReleases.vue": 17875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92378;